import React from "react";
import "./ProductUpdateAnnouncement.css";
import { attachLinkedImage } from "../utils/productUpdateAnnouncementPages.js";

// The same renderer is used by the Journal, preview and announcement.
export default function ProductUpdatePublicationView({ content: rawContent, page = null, animated = false, compact = false }) {
  const content = attachLinkedImage(rawContent);
  const sections = content?.sections || [];
  // The Journal and announcement use thumbnails that enlarge on click.
  const [zoomed, setZoomed] = React.useState(null);
  function renderSingleImage(image, key, interactive) {
    const picture = <img className="product-update-illustration" src={image.data_url} alt={image.alt} />;
    return interactive ? <button type="button" className={`product-update-item-image${zoomed === key ? " is-zoomed" : ""}`}
      aria-expanded={zoomed === key} title={zoomed === key ? "Réduire l'image" : "Agrandir l'image"}
      onClick={() => setZoomed(current => current === key ? null : key)}>{picture}</button> : picture;
  }
  function renderImage(image, key, interactive = animated || compact) {
    if (!image.additional_images?.length) return renderSingleImage(image, key, interactive);
    return <div className="product-update-image-pair">
      {renderSingleImage(image, key, interactive)}
      {image.additional_images.map((extra, index) => <React.Fragment key={index}>{renderSingleImage(extra, `${key}-${index + 2}`, interactive)}</React.Fragment>)}
    </div>;
  }
  const subjects = sections.map((section, index) => <section key={section.subject} hidden={page !== null && index !== page}
      className="product-update-subject" style={{ "--reveal-delay": `${index * 70}ms` }} aria-label={section.subject}>
      <h3>{section.subject}</h3>
      <ul>{section.items.map(item => <li key={item.item_id} className={item.image && (animated || compact) ? "has-image" : undefined}>
        <h4>{item.title}</h4><p>{(compact ? item.text.replace(/\n\s*\n/g, "\n") : item.text).split(/\*\*([^*\n]+?)\*\*/g).map((part, index) => index % 2 ? <strong key={index}>{part}</strong> : part)}</p>
        {item.image && renderImage(item.image, `item-${item.item_id}`)}
      </li>)}</ul>
    </section>);
  return <div className={`product-update-content${animated ? " product-update-content--animated" : ""}${compact ? " product-update-content--compact" : ""}`}>
    {compact && content?.image ? <div className="product-update-journal-layout">
      <div className="product-update-journal-subjects">{subjects}</div>
      <div className="product-update-journal-images">{renderImage(content.image, "common", true)}</div>
    </div> : <>{content?.image && renderImage(content.image, "common", compact)}{subjects}</>}
  </div>;
}
